import { Action, createReducer, on } from '@ngrx/store';
import * as _ from 'lodash';
import { CACHED_HEADER, CACHED_REQUEST_STATUS } from '../../classes/cached-request';
import {
    addGetRequestsToQueue,
    refreshAllRequests,
    refreshRequest,
    updateGetRequestInQueue,
} from '../actions/refresh-request-queue.actions';
import { initialRefreshRequestQueueState, RefreshRequestQueueState } from '../types/refresh-request-queue.state';

const addGetRequestsToQueueReducer = (
    state: RefreshRequestQueueState,
    props: { uriContent: string; requests: string[] },
): Readonly<RefreshRequestQueueState> => {
    let refreshRequests = state.refreshRequests ? state.refreshRequests : {};
    const cacheRequests = Object.keys(refreshRequests);
    if (props && props.requests) {
        props.requests.forEach((request) => {
            const url = props.uriContent + request;
            const requestUrl = request.split('?')[0];

            const matchedRequest = cacheRequests.find((cachedRequest) => cachedRequest === requestUrl);
            if (!matchedRequest) {
                refreshRequests = {
                    ...refreshRequests,
                    [requestUrl]: {
                        url,
                        headers: { [CACHED_HEADER]: CACHED_HEADER },
                        refreshStatus: CACHED_REQUEST_STATUS.PENDING,
                    },
                };
            }
        });
    }
    return { refreshRequests };
};

const updateGetRequestToQueueReducer = (
    state: RefreshRequestQueueState,
    props: { url: string; refreshStatus: CACHED_REQUEST_STATUS },
): RefreshRequestQueueState => {
    // We need to use cloneDeep cause otherwise we are trying to change directly the state which is read-only
    const refreshRequests = _.cloneDeep(state.refreshRequests);
    if (props.url && props.refreshStatus) {
        for (const cachedUrl in refreshRequests) {
            if (refreshRequests.hasOwnProperty(cachedUrl)) {
                if (props.url.indexOf(cachedUrl) > -1) {
                    refreshRequests[cachedUrl].refreshStatus = props.refreshStatus;
                    refreshRequests[cachedUrl].headers = { [CACHED_HEADER]: CACHED_HEADER };
                }
            }
        }
    }
    return { refreshRequests };
};

const refreshRequestReducer = (state: RefreshRequestQueueState, props: { url: string }): RefreshRequestQueueState => {
    // We need to use cloneDeep cause otherwise we are trying to change directly the state which is read-only
    const refreshRequests = _.cloneDeep(state.refreshRequests);
    if (props.url) {
        const matchedRequest = refreshRequests[props.url];
        if (matchedRequest) {
            matchedRequest.refreshStatus = CACHED_REQUEST_STATUS.PENDING;
        }
    }
    return { refreshRequests };
};

const refreshAllRequestsReducer = (state: RefreshRequestQueueState): RefreshRequestQueueState => {
    // We need to use cloneDeep cause otherwise we are trying to change directly the state which is read-only
    const refreshRequests = _.cloneDeep(state.refreshRequests);
    Object.values(refreshRequests).forEach((request) => {
        request.refreshStatus = CACHED_REQUEST_STATUS.PENDING;
    });
    return { refreshRequests };
};

const createRefreshRequestQueueReducer = createReducer(
    initialRefreshRequestQueueState,
    on(addGetRequestsToQueue, addGetRequestsToQueueReducer),
    on(updateGetRequestInQueue, updateGetRequestToQueueReducer),
    on(refreshRequest, refreshRequestReducer),
    on(refreshAllRequests, refreshAllRequestsReducer),
);

export function refreshRequestQueueReducer(
    state: Readonly<RefreshRequestQueueState>,
    action: Action,
): Readonly<RefreshRequestQueueState> {
    return createRefreshRequestQueueReducer(state, action);
}
